export enum UserRoleEnum {
    HC_INTERNAL_ADMIN = 'HC_INTERNAL_ADMIN',
    HC_INTERNAL_SUPPLIER_ADMIN = 'HC_INTERNAL_SUPPLIER_ADMIN',
    HC_INTERNAL_CARRIER_ADMIN = 'HC_INTERNAL_CARRIER_ADMIN'
}